<template>
  <div class="team">
    <header>
      <h3>{{ title }}</h3>
      <span>{{ subTitle }}</span>
    </header>
    <div class="full-chart-icon" @click="fullScreen">
      <span class="icon iconfont icon-jt-quanping_o" title="全屏展示"></span>
    </div>
    <div id="team" style="height: 300px">
      <div ref="target" style="width: 100%; height: 100%"></div>
    </div>
  </div>
</template>
<script>
import * as echarts from "echarts"
import { mapState } from "vuex"
export default {
  props: {
    dataList: {
      type: Array,
      default: () => [],
    },
    title: {
      type: String,
      default: "制作人员工作量",
    },
    subTitle: {
      type: String,
      default: "(完成量:制作完成时间，其他:落点时间)",
    },
  },
  data() {
    return {
      myChart: null,
    }
  },
  computed: {
    ...mapState({
      sidebarOpened: (state) => state.app.sidebar.opened,
    }),
  },
  mounted() {
    this.myChart = echarts.init(this.$refs.target)
    this.renderChart()
    window.addEventListener("resize", this.handleResize)
  },

  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize)

    // 移除全屏状态变化监听器
    document.removeEventListener(
      "fullscreenchange",
      this.handleFullscreenChange
    )
    document.removeEventListener(
      "webkitfullscreenchange",
      this.handleFullscreenChange
    )
    document.removeEventListener(
      "mozfullscreenchange",
      this.handleFullscreenChange
    )
    document.removeEventListener(
      "MSFullscreenChange",
      this.handleFullscreenChange
    )

    this.myChart && this.myChart.dispose()
  },

  methods: {
    // fullScreen() {
    //   this.$emit("full", Math.random())
    // },
    fullScreen(platId = Math.random()) {
      const element = document.getElementById("team")
      if (!element) return
      // IE 10及以下ActiveXObject
      if (window.ActiveXObject) {
        const WsShell = new ActiveXObject("WScript.Shell")
        WsShell.SendKeys("{F11}")
      } else if (element.requestFullScreen) {
        // HTML W3C 提议
        element.requestFullScreen()
      } else if (element.msRequestFullscreen) {
        // IE11
        element.msRequestFullScreen()
      } else if (element.webkitRequestFullScreen) {
        // Webkit (works in Safari5.1 and Chrome 15)
        element.webkitRequestFullScreen()
      } else if (element.mozRequestFullScreen) {
        // Firefox (works in nightly)
        element.mozRequestFullScreen()
      }

      // 添加全屏状态变化监听
      this.addFullscreenChangeListener()
    },

    // 添加全屏状态变化监听器
    addFullscreenChangeListener() {
      const element = document.getElementById("team")
      if (!element) return

      // 监听全屏状态变化
      document.addEventListener("fullscreenchange", this.handleFullscreenChange)
      document.addEventListener(
        "webkitfullscreenchange",
        this.handleFullscreenChange
      )
      document.addEventListener(
        "mozfullscreenchange",
        this.handleFullscreenChange
      )
      document.addEventListener(
        "MSFullscreenChange",
        this.handleFullscreenChange
      )
    },

    // 处理全屏状态变化
    handleFullscreenChange() {
      const element = document.getElementById("team")
      if (!element) return

      // 判断是否处于全屏状态
      const isFullscreen =
        document.fullscreenElement ||
        document.webkitFullscreenElement ||
        document.mozFullScreenElement ||
        document.msFullscreenElement

      if (isFullscreen) {
        // 进入全屏时添加全屏样式类
        element.classList.add("fullscreen-chart")
        // 可以在这里重新设置图表样式以适应全屏
        if (this.myChart) {
          this.myChart.resize()
        }
      } else {
        // 退出全屏时移除全屏样式类
        element.classList.remove("fullscreen-chart")
        if (this.myChart) {
          this.myChart.resize()
        }
      }
    },
    renderChart() {
    
      // 创建echarts配置
      const options = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
          formatter: function (params) {
            let result = params[0].name + "<br/>"
            params.forEach((param) => {
              result +=
                param.marker + param.seriesName + ": " + param.value + "<br/>"
            })
            return result
          },
        },
        legend: {
          data: ["需求量", "完成量", "产能剩余"],
          right: "center",
          bottom: "0",
          orient: "horizontal",
          width: "100%",
          itemWidth: 12,
          itemHeight: 12,
          textStyle: {
            fontSize: 12
          },
          type: 'scroll',
          pageButtonGap: 5,
          pageIconSize: 12,
          pageButtonItemGap: 5
        
        },
        grid: {
          left: "3%",
          right: "10%",
          bottom: "10%",
          top: "10%",
          containLabel: true,
        },
        xAxis: {
          type: "value",
          min: this.dataList.length ? Math.min(...this.dataList.map(item => item.excess_capacity<0?item.excess_capacity:0)) : 0,
          // max: 120,
        },
        yAxis: {
          type: "category",
          data: this.dataList.map((item) => item.name),
          axisLabel: {
            fontSize: 11 // 稍微减小字体大小
          },
          inverse: true // 反转坐标轴，确保数据从上到下按后端返回的从大到小顺序显示
        },
        dataZoom: [
          {
            type: "inside",
            yAxisIndex: 0,
            start: 0,
            end: 100,
            orient: "vertical",
          },
          {
            type: "slider",
            yAxisIndex: 0,
            start: 0,
            end: 60,
            orient: "vertical",
            height: "70%",
            bottom: "15%",
          },
        ],
        series: [
          {
            name: "需求量",
            type: "bar",
            data: this.dataList.map((item) => item.demand_num),
            itemStyle: {
              color: "#ff7875",
            },
          },
          {
            name: "完成量",
            type: "bar",
            data: this.dataList.map((item) => item.upload_material_num),
            itemStyle: {
              color: "#73d13d",
            },
          },
          {
            name: "产能剩余",
            type: "bar",
            data: this.dataList.map((item) => item.excess_capacity),
            itemStyle: {
              color: "#faad14",
            },
          },
        ],
      }
      // 设置图表配置
      this.myChart.setOption(options)
    },

    handleResize() {
      this.myChart && this.myChart.resize()
    },
  },
  watch: {
    dataList: {
      handler(newVal, oldVal) {
        this.renderChart()
      },
      deep: true,
    },
    // 监听侧边栏状态变化，重新渲染图表
    sidebarOpened() {
      this.renderChart()
      setTimeout(() => {
        if (this.myChart) {
          this.handleResize()
        }
      }, 200)
    },
  },
}
</script>

<style scoped lang="scss">
.team {
  position: relative;
  header {
    display: flex;
    align-items: center;
    span {
      color: #a9afb9;
      margin-left: 10px;
    }
  }
  .full-chart-icon {
    width: 30px;
    height: 30px;
    position: absolute;
    right: 0;
    top: 5px;
    cursor: pointer;
    z-index: 1;
  }

  // 全屏状态下的样式
  #team.fullscreen-chart {
    position: fixed;
    top: 0;
    left: 0;
    width: 100% !important;
    height: 100% !important;
    background-color: #f0f2f5;
    z-index: 9999;

    // 全屏时图表容器的样式
    > div {
      height: 100% !important;
    }
  }
}
</style>
